import { Menu, Transition } from '@headlessui/react';
import React, { Fragment, useMemo } from 'react';

interface INotificationMenuProps {
  undreadMessages: any[];
  orderList: any[];
  handleOrderSelect: (orderId: number, type: string) => void;
}

export default function NotificationMenu({ undreadMessages, orderList, handleOrderSelect }: INotificationMenuProps) {
  const groupedMessages = useMemo(
    () =>
      undreadMessages
        .sort((a, b) => +new Date(b.inserted) - +new Date(a.inserted))
        ?.reduce((acc, message) => {
          if (!acc.some(({ sender }: { sender: string }) => sender === message.sender)) {
            return [...acc, message];
          }
          return acc;
        }, [] as any),
    [undreadMessages]
  );

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button disabled={undreadMessages?.length === 0} className="bg-white border text-sm border-divider disabled:opacity-50 disabled:bg-neutral-100 h-10  w-10 flex-center rounded-md">
          <i className="ri-notification-line" />
          {undreadMessages?.length > 0 && (
            <div className="absolute -top-1 -right-1 bg-sky-500 rounded-full text-xs flex justify-center items-center p-2 text-white w-3 h-3">
              {groupedMessages?.length}
            </div>
          )}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute z-20 left-0 mt-2 w-64 shadow-sm origin-top-right border border-divider divide-y divide-neutral-200 rounded-md bg-white  focus:outline-none">
          {groupedMessages?.map(({ message, sender, name, inserted }: any) => (
            <div className="px-1 py-1 ">
              <Menu.Item>
                <button
                  onClick={() => handleOrderSelect(orderList?.find(order => order.orderId.toString() === sender)?.orderId, 'chat')}
                  className="flex gap-x-2 w-full items-start bg-white text-black"
                >
                  <div>
                    <div className="bg-cyan-500 text-white flex items-center w-10 h-10 justify-center overflow-hidden    rounded-full">
                      {orderList?.find(({ orderId }) => orderId.toString() === sender)?.profileImage ? (
                        <img
                          src={orderList?.find(({ orderId }) => orderId.toString() === sender)?.profileImage}
                          alt={`${orderList?.find(({ orderId }) => orderId.toString() === sender)?.firstName?.[0]}${
                            orderList?.find(({ orderId }) => orderId.toString() === sender)?.lastName?.[0]
                          }`}
                        />
                      ) : (
                        <span>
                          {orderList?.find(({ orderId }) => orderId.toString() === sender)?.firstName?.[0]}
                          {orderList?.find(({ orderId }) => orderId.toString() === sender)?.lastName?.[0]}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-y- w-full justify-start text-left max-w-[calc(100%_-_45px)]">
                    <div className="flex justify-between w-full">
                      <span className="font-semibold text-sm">{name}</span>
                      <span className="text-xs">{new Date(inserted)?.toLocaleTimeString('sv-SE')}</span>
                    </div>

                    <span className=" text-sm">{message}</span>
                  </div>
                </button>
              </Menu.Item>
            </div>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
